<template>
  <lit-list-view
    :items="orderedSources"
  ></lit-list-view>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  components: {
    LitListView: require('./LitListView.vue')
  },
  props: {
    sources: Object
  },
  computed: {
    ...mapGetters(['orderedSources']),
    sortedSources () {
      return _.sortBy(this.sourcesList, s => s.number ? s.number : 9999)
    },
    sourcesList () {
      // return _.values(this.sources)
      let result = []
      Object.keys(this.sources).forEach((id) => {
        result.push({...this.sources[id], id})
      })
      return result
    }
  }
}
</script>


// WEBPACK FOOTER //
// LitListContainer.vue?3672ad3a